import { render, staticRenderFns } from "./Aiki.vue?vue&type=template&id=1720afc4&"
import script from "./Aiki.vue?vue&type=script&lang=js&"
export * from "./Aiki.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports